import { render, staticRenderFns } from "./IpOctetInput.vue?vue&type=template&id=45f4c2b7&"
import script from "./IpOctetInput.vue?vue&type=script&lang=ts&"
export * from "./IpOctetInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports